import { objectOf, maybe, anyOf } from "@altostra/type-validations";
import { boolean, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

import type { SegmentFilterReachableAudienceStatsPayload } from "./types";

const isChannelStat = maybe(
  objectOf({
    total: number,
    margin_of_error: anyOf(maybe(number), nullOrUndefined),
    revenue: number,
  })
);

export const isAppsAndFiltersPreview = objectOf<SegmentFilterReachableAudienceStatsPayload>({
  is_cached: maybe(boolean),
  calculated_at: maybe(number),
  distributed: boolean,
  summary_statistics: objectOf({
    estimated: boolean,
    total_app_users: number,
    total_segment_users: number,
    total_segment_users_margin_of_error: anyOf(maybe(number), nullOrUndefined),
    revenue_total_in_cents: maybe(number),
    channel_statistics: maybe(
      objectOf({
        email: isChannelStat,
        iosPush: isChannelStat,
        androidPush: isChannelStat,
        webPush: isChannelStat,
        kindlePush: isChannelStat,
      })
    ),
  }),
});
